import { zodResolver } from "@hookform/resolvers/zod";
import type { SubmitHandler } from "react-hook-form";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import { useAuthentication } from "@/hooks";
import type { LoginFormValuesType } from "@/types";
import { loginFormSchema } from "@/types";
import { Button, FormField, Input, PasswordInput } from "@/ui";
import { Spinner } from "@/ui/common";

export const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormValuesType>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const { useLogin } = useAuthentication();
  const { mutate: login, isPending, error: loginError } = useLogin();
  const onSubmit: SubmitHandler<LoginFormValuesType> = (values) => {
    login(values);
  };

  return (
    <>
      <h1 className="text-center text-2xl font-bold text-primary-950">
        Sign in
      </h1>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-10">
        <FormField label="Email" error={errors.email?.message}>
          <Input
            placeholder="Enter your email"
            {...register("email")}
            error={errors.email?.message ?? loginError?.message}
          />
        </FormField>

        <FormField label="Password" error={errors.password?.message}>
          <PasswordInput
            placeholder="Enter your password"
            {...register("password")}
            error={errors.password?.message ?? loginError?.message}
          />
          {loginError && <p className="text-error-500">{loginError.message}</p>}
        </FormField>
        <Link
          to={"/forgot-password"}
          className="self-end border-b text-sm font-bold text-primary-950"
        >
          Forgot your password?
        </Link>
        <Button className="mt-8 w-full font-semibold" type="submit">
          {isPending ? <Spinner /> : "Sign in"}
        </Button>
      </form>
    </>
  );
};
